import { IMDSCalendarHeadingProps } from "./calendar-heading.types";
import { StyledCalendarHeading } from "./calendar-heading.style";

export function MDSCalendarHeading(props: IMDSCalendarHeadingProps) {
  return <StyledCalendarHeading {...props} />;
}
